export default "__VITE_ASSET__c8619512__"